import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { FileItem } from '@models/file-item.model';
import { Product } from '@models/product.model';
import { PurchaseOrderDto } from '@app/models/purchase-order.model.dto';
import { Shipment } from '@models/shipment.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from '@services/file.service';
import { ShipmentService } from '@services/shipment.service';
import { SweetAlertService } from '@services/sweet-alert.service';
import { Toaster } from '@services/toaster.service';
import { LocalStorage } from 'ngx-webstorage';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'ngx-shipment-tracking-detail',
  templateUrl: './shipment-tracking-detail.component.html',
  styleUrls: ['./shipment-tracking-detail.component.scss'],
})
export class ShipmentTrackingDetailComponent implements OnInit {
  @LocalStorage() organizationId;
  @Input() companyType: string;
  @Input() shipment: Shipment;
  @Input() products: Product[];
  @Input() purchaseOrder: PurchaseOrderDto;

  constructor(
    public activeModal: NgbActiveModal,
    private shipmentService: ShipmentService,
    private fileService: FileService,
    private $toaster: Toaster,
    private sweetAlertService: SweetAlertService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document,
  ) { }

  ngOnInit() {
    this.shipment.line_items = this.shipment.line_items.map((shipmentLineItem) => {
      if (shipmentLineItem.name) return shipmentLineItem;

      const PoLineItem = this.purchaseOrder.line_items.find(item => item.id === shipmentLineItem.line_item_id);
      if (PoLineItem) {
        shipmentLineItem.name = PoLineItem.product_name || this.displayProductName(PoLineItem.product_id);
      }
      return shipmentLineItem;
    });
  }

  // TODO remove this function when backend add the product name to line items
  displayProductName(productId: string): string {
    const prod = this.products.find((p: any) => p.id === productId);
    return !!prod ? prod.name : productId;
  }

  getFile(file: FileItem) {
    this.shipmentService.getShipmentFile(this.organizationId, this.purchaseOrder.id, this.shipment.id, file.file_id)
      .subscribe((blobFile) => {
        file.file_name.endsWith('.pdf') ?
          this.fileService.viewPdf(blobFile, file.file_name) :
          this.fileService.downloadBlobFile(blobFile, file.file_name);
      });
  }

  deleteFile(file) {
    // const modalRef = this.document.getElementsByClassName('shipment-tracking-detail')[0];
    const modalBackdropRef = this.document.getElementsByClassName('modal-backdrop')[0];
    setTimeout(() => {
      // this.renderer2.removeClass(modalRef, 'show');
      this.renderer2.removeClass(modalBackdropRef, 'show');

    }, 100);
    this.sweetAlertService.deleteConfirmation().then((result) => {
      // this.renderer2.addClass(modalRef, 'show');
      this.renderer2.addClass(modalBackdropRef, 'show');
      if (result.value) {
        this.shipmentService.deleteShipmentFile(this.organizationId, this.purchaseOrder.id, this.shipment.id, file.file_id)
          .pipe(switchMap(() => this.shipmentService.getShipmentPORelated(this.organizationId, this.purchaseOrder.id, this.shipment.id)))
          .subscribe((shipment) => {
            this.shipment = shipment;
            this.$toaster.show('success', 'Shipment File', 'Shipment file deleted!');
          }, (error) => {
            const errMsg =
              error.error && error.error.detail ? error.error.detail : 'An error occurred while deleting the file.';
            this.$toaster.show('error', 'Shipment File', errMsg);
          });
      }
    });
  }

}
